// extracted by mini-css-extract-plugin
export default {"heading":"DataRemaining_heading__gXwA0"};